import { Badge, Button, Col, Collapse, Drawer, Flex, Row } from "antd";
import React from "react";
import { ArrowRightIcon, CheckedIcon, SparkleIcon } from "../Icons";

function PolicyDetail({ data, sidebar = true, bgColor }) {
  const notes = [
    {
      key: "1",
      label: (
        <div className="header">
          <h6>Data Collection and Consent</h6>
          <Badge count={1} className="count-badge" />
          <CheckedIcon />
        </div>
      ),
      children: (
        <div className="content">
          <h5>Missing explicit consent statement for email collection.</h5>
          <p>
            Add a clear checkbox requiring user consent before data collection
          </p>
          <Flex gap={16} className="btns">
            <Button type="primary">Apply Revision</Button>
            <Button type="text">Reject</Button>
          </Flex>
        </div>
      ),
    },
    {
      key: "2",
      label: (
        <div className="header">
          <h6>Data Retention Policy</h6>
          <Badge count={2} className="count-badge" />
        </div>
      ),
      children: (
        <div className="content">
          <h5>Retention period not justified for user data.</h5>
          <p>
            Provide a legal basis for retaining user data for 2 years or
            consider reducing the retention period.
          </p>
          <Flex gap={16} className="btns">
            <Button type="primary">Apply Revision</Button>
            <Button type="text">Reject</Button>
          </Flex>
        </div>
      ),
    },
    {
      key: "3",
      label: (
        <div className="header">
          <h6>Data Breach Notification</h6>
          <Badge count={3} className="count-badge" />
        </div>
      ),
      children: (
        <div className="content">
          <h5>
            No mention of internal reporting process before notifying
            authorities.
          </h5>
          <p>
            Include a step where security teams internally assess the breach
            before external notifications.
          </p>
          <Flex gap={16} className="btns">
            <Button type="primary">Apply Revision</Button>
            <Button type="text">Reject</Button>
          </Flex>
        </div>
      ),
    },
  ];
  return (
    <Row gutter={[30, 0]}>
      <Col span={sidebar ? 14 : 24}>
        <div
          className="policy-detail"
          style={{ backgroundColor: bgColor ? bgColor : "transparent" }}
        >
          <h1 className="main-heading">{data.title}</h1>
          <p className="intro">
            <span>Introduction:</span> <mark>{data.introduction}</mark>
          </p>
          {data?.data?.map((item) => (
            <div className="policy-section">
              <h2 className="title">
                {item.id}. {item.title}
              </h2>

              {item.description && (
                <p className="description">{item.description}</p>
              )}

              {item.points && item.points.length > 0 && (
                <ul className="list">
                  {item.points.map(({ items, title }, index) => (
                    <li key={index}>
                      <span className="list-title">{title}</span>
                      {items && items.length > 0 && (
                        <ul className="sub-list">
                          {items.map((subitem, subIndex) => (
                            <li key={subIndex}>{subitem}</li>
                          ))}
                        </ul>
                      )}
                    </li>
                  ))}
                </ul>
              )}

              {item.note && <p className="note">Note: {item.note}</p>}
            </div>
          ))}
          <p className="conclusion">
            <span>Conclusion:</span> {data.conclusion}
          </p>
        </div>
      </Col>
      {sidebar && (
        <Col span={10}>
          <div className="notes-parent">
            <h1 className="main-heading">
              <SparkleIcon /> AI Notes
            </h1>
            <Collapse
              className="notes-collapse"
              bordered={false}
              ghost
              items={notes}
              expandIcon={() => (
                <div>
                  <ArrowRightIcon />
                </div>
              )}
            />
            <Button type="primary">Generate Report</Button>
          </div>
        </Col>
      )}
    </Row>
  );
}

export default PolicyDetail;
